import React, { useState,useEffect } from "react";
import StudentSidebar from "../../../common/Sidebar/StudentSideBar";
import "./StudentMeet.css";
function StudentMeet({ educator }) {
  const [link,setLink] = useState("");

  useEffect(()=>{
    const u=JSON.parse(localStorage.getItem('user'));
    setLink("https://edtechv.netlify.app/call/"+u._id);

  },[]);
  function myFunction() {
    var copyText = document.getElementById("myInput");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    alert("Copied the text: " + copyText.value);
  }
  return (
    <div className="educator-home">
      <StudentSidebar />
      <div className="home-main" style={{height:"100vh"}}>
        <h1>Student Meet</h1>
        <p>Press the button to start the meet and share link with your peers!</p>
        <div>
          <a type="button" className="btn btn-warning" href={link}>Start Meet</a>
        </div>
        <div className="input-group mb-3" style={{marginTop:"50px"}}>
           <input type="text" value={link} className="form-control" placeholder="Recipient's username" id="myInput" aria-label="Recipient's username" aria-describedby="basic-addon2" disabled/>
            <button className="input-group-text" id="basic-addon2" onClick={myFunction}>Copy</button>
        </div>
      </div>
    </div>
  );
}

export default StudentMeet;
